import React from "react";
import { Flex } from "@singlestore/fusion/components/layout";
import {
    textVariantPropsKeys,
    textVariants,
} from "@singlestore/fusion/components/typography";
import { split } from "@singlestore/fusion/utils/object";
import { cva, VariantProps } from "class-variance-authority";

import "./Card.scss";

export const card = cva("card", {
    variants: {
        ...textVariants,
        cardSize: {
            "cards-small": "small",
            "cards-large": "large",
        },
    },
});

type CustomCardProps = {
    className?: string;
};

export type CardProps = React.PropsWithChildren<CustomCardProps> &
    VariantProps<typeof card>;

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ children, className, cardSize, ...rest }, fowardedRef) => {
        const [variantProps, divProps] = split(rest, textVariantPropsKeys);

        const classes = card({
            ...variantProps,
            className,
            cardSize,
        });

        return (
            <Flex ref={fowardedRef} className={classes} {...divProps}>
                {children}
            </Flex>
        );
    }
);
